export const GET_IMAGES = 'GET_IMAGES'
export const DELETE_IMAGE = 'DELETE_IMAGE'
export const UPDATE_IMAGE = 'UPDATE_IMAGE'
export const GET_ACTIVE_ANALYSIS = 'GET_ACTIVE_ANALYSIS'
export const DELETE_ACTIVE_ANALYSIS = 'DELETE_ACTIVE_ANALYSIS'
